import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesSection() {
  const items = ['Protocolo completo de 14 noches paso a paso', 'El Plan 3:00am (qué hacer cuando despiertas)', 'Plantillas: Tracker de 14 noches + Descarga mental', 'Planes B de 3 minutos para noches caóticas', 'Guía de mantenimiento (cómo retomar después de una mala noche)'];
  return <div className="py-16 px-4 sm:px-6 bg-white" data-id="element-109">
      <div className="max-w-4xl mx-auto" data-id="element-110">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-navy-900 mb-12" data-id="element-111">
          Qué incluye "Dormir Sin Pensar"
        </motion.h2>

        <div className="grid sm:grid-cols-2 gap-4" data-id="element-112">
          {items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex items-start p-4 bg-cream-50 rounded-xl border border-cream-200" data-id="element-113">
              <CheckCircle2 className="w-6 h-6 text-amber-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-114" />
              <p className="text-navy-700 font-medium" data-id="element-115">{item}</p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}